.dh-mfc {
    .skeleton-section {
        max-width: 100%;
    }

    .container-financial-products {
        margin-top: -10px;
        margin-bottom: 40px;
        display: flex;
        justify-content: space-between;
    }

    .container-financial-products > .child-financial-products {
        width: calc(50% - 11px);
    }

    .container-totals {
        display: flex;
    }

    .container-totals > .child-container-totals > .total-text {
        width: 37%;
    }

    .container-totals > .child-container-totals > .total-number {
        width: 28%;
    }

    .container-totals > .child-container-totals:first-child {
        width: 90%;
    }

    .container-totals > .child-container-totals:last-child {
        width: 10%;
        display: flex;
        align-items: center;
    }

    .container-totals > .child-container-totals:last-child > .child-container-totals-item {
        width: 100%;
        margin-top: -40px;
    }

    .title-text {
        width: 25%;
        margin-top: 24px;
    }

    .summary-text {
        width: 33%;
    }

    .text-lg {
        margin-top: -10px;
    }

    .title-financial-products {
        width: 25%;
        margin-top: 45px;
    }

    .separator-line {
        margin-top: 60px;
    }

    .title-selector,
    .title-selector-1 {
        width: 33%;
    }

    .title-selector-1 {
        margin-top: 30px;
    }

    .content-selector {
        width: 58%;
    }

    .container-selector > .title-selector:last-child,
    .title-selector-1:last-child {
        display: none;
    }

    .container-selector > .content-selector:last-child {
        display: none;
    }

    @media (max-width: 700px) {
        .title-text {
            width: 70%;
        }

        .summary-text {
            width: 100%;
        }

        .title-financial-products {
            width: 50%;
        }

        .container-financial-products {
            flex-direction: column;
        }

        .container-financial-products > .child-financial-products {
            width: 100%;
        }

        .container-totals {
            flex-direction: column;
        }

        .container-totals > .child-container-totals > .total-text {
            width: 50%;
        }

        .container-totals > .child-container-totals > .total-number {
            width: 80%;
        }

        .container-totals > .child-container-totals > .total-number:last-child {
            width: 90%;
        }

        .container-totals > .child-container-totals:first-child {
            width: 100%;
        }

        .container-totals > .child-container-totals:last-child {
            width: 100%;
            justify-content: center;
        }

        .container-totals > .child-container-totals:last-child > .child-container-totals-item {
            width: 100%;
            margin-top: 30px;
        }

        .container-selector {
            display: flex;
            flex-direction: column;
        }

        .container-selector > .content-selector:last-child {
            display: block;
        }

        .title-selector,
        .title-selector-1 {
            width: 50%;
        }

        .title-selector-1 {
            margin-top: 0px;
        }

        .content-selector {
            width: 100%;
        }
    }
}
